export enum IDeclarationStatusActionTypes {
  GET_DECLARATION_STATUS = '@@declarationStatus/GET_DECLARATION_STATUS',
  GET_DECLARATION_STATUS_SUCCESS = '@@declarationStatus/GET_DECLARATION_STATUS_SUCCESS',
  GET_DECLARATION_STATUS_FAILURE = '@@declarationStatus/GET_DECLARATION_STATUS_FAILURE',
}

export interface IDeclarationStatus {
  response: ResponseDeclarationStatus | null;
  isLoading: boolean;
  error: string;
}

export interface ResponseDeclarationStatus {
  status: string;
  status_code: number;
  results: Result[];
}

export interface Result {
  bucket_id: number;
  reference_ad_id: number;
  user_group_id: number;
  signature_status: any;
  created_at: string;
  last_modified: string;
}
